import http from '@/utils/http'

export function fetchMyFairHouses() {
  return http.get("/api/weixin/fetchMyFairHouses")
}

export function selectHtDetail(htId) {
  return http.get("/api/weixin/htDetail/" + htId)
}

export function selectQsHtDetail(htId,fwxz) {
  return http.get("/api/weixin/htQsDetail/" + htId+"/"+fwxz)
}

export function submitTaxSubsidiesApply(data) {
  return http.post('/api/weixin/taxSubsidiesApply', data)
}

export function submitUpdateNewBankCard(data){
  return http.post('/api/weixin/updateNewBankCard', data)
}

export function taxQsSubsidiesApply(file,data) {
  return http.upload('/api/weixin/taxQsSubsidiesApply',file,data)
}
export function selectApplyHtDetail(data) {
  return http.post("/api/weixin/selectApplyHtDetail" , data)
}

export function updateTaxQsSubsidiesApply(file,data) {
  return http.upload('/api/weixin/updateTaxQsSubsidiesApply',file,data)
}

